import { Firebase } from './app';
import 'firebase/storage';

export default Firebase.storage();
